export default __webpack_public_path__ + "static/media/ic_money.07febfc0.svg";